/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";

// One root-scoped Family service worker controls the whole site. Register it
// from every entry point (home, login, and each module route) so any deep link
// installs/activates the same worker. There are no per-app service workers.
if ("serviceWorker" in navigator) {
  const registerServiceWorker = () => {
    void navigator.serviceWorker.register("/sw.js", { scope: "/" });
  };
  if (document.readyState === "complete") {
    registerServiceWorker();
  } else {
    window.addEventListener("load", registerServiceWorker, { once: true });
  }
}

const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <App />
  </StrictMode>
);

// https://bun.com/docs/bundler/hot-reloading#import-meta-hot-data
(import.meta.hot.data.root ??= createRoot(elem)).render(app);
